export const BASE_NAME = "base_display_name";
export const BIPP_NAME = "bipp_name";
export const BUILDING_SITE = "building_site";
export const CLIENT_NAME = "client_name";
export const COLOR_CODE = "color_code";
export const COLOR_NAME = "color_display_name";
export const COLOR_STATS_TYPE = "color_stats_type";
export const CREATED = "created";
export const CUSTOMER_NAME = "customer_name";
export const FANDECK_NAME = "fandeck_display_name";
export const ID = "id";
export const MORE_INFO = "more_info";
export const MORE_INFO_INTERNAL = "more_info_internal";
export const NAME = "name";
export const NOMINAL_AMOUNT = "nominal_amount";
export const OPERATOR = "user_login";
export const PACKAGE_COUNT = "package_count";
export const PACKAGE_NAME = "package_name";
export const PRICE_GROUP = "price_group";
export const PRODUCT_NAME = "product_display_name";
export const PURCHASE = "purchase";
export const STATUS = "order_status_id";
export const TIMESTAMP = "timestamp_utc";
export const UPDATED = "updated";
export const VAT = "vat";
